import { render, staticRenderFns } from "./OnboardingTextSection.vue?vue&type=template&id=9a52be54"
import script from "./OnboardingTextSection.vue?vue&type=script&lang=js"
export * from "./OnboardingTextSection.vue?vue&type=script&lang=js"
import style0 from "./OnboardingTextSection.vue?vue&type=style&index=0&id=9a52be54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports